export default __webpack_public_path__ + "static/bg_header_day-3ef256149b71dadec96466ae66c8edf8.svg";